export default "__VITE_ASSET__wwU6c0dk__"